import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeDailyFiveContentItemContent$key } from "~/queries/__generated__/homeDailyFiveContentItemContent.graphql";

import { Container, Headline, StyledEntityLink } from "./styles";

export type Props = {
  reference: homeDailyFiveContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemDailyFive = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeDailyFiveContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <Headline>
            {provider.headline({
              hideTooltip: true,
              preferSocialHeadline: true,
            })}
          </Headline>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemDailyFive.displayName = "ContentItemDailyFive";
